import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { media } from 'ui/rwd'
import { CONTENT_WIDTH, pageGutter } from '../HomepageStyledComponents'

const PageHeader = styled.header`
  position: relative;
  z-index: 2;
  width: 100%;
  background-color: ${theme('white')};
  border-bottom: 1px solid ${theme('lightGray')};
  box-shadow: 0 2px 12px -6px rgba(30, 27, 28, 0.18);
`

const HeaderInner = styled.div`
  display: flex;
  align-items: center;
  max-width: ${CONTENT_WIDTH};
  margin: 0 auto;
  ${pageGutter};
  padding-top: 1rem;
  padding-bottom: 1rem;
  ${media.sm`
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  `}
`

const HeaderLogo = styled.div`
  display: flex;
  align-items: center;

  img {
    height: 32px;
    cursor: pointer;
    ${media.sm`
      height: 40px;
    `}
  }
`

export { PageHeader, HeaderInner, HeaderLogo }
